export enum AppNotificationAction {
  REDIRECT = 'redirect',
  MODAL = 'modal',
  MESSAGE = 'message',
  RATINGS_MODAL = 'rating_modal'
}
